import {
  CHECK_BOX_VALUE,
  CONTRACTS_DATA,
  GRID_ROWS_PER_PAGE,
  SWITCH_VALUE,
} from '../../../constants';
export const initialState = {
  isContractLoading: false,
  selectededTab: 0,
  prevSelectedTab: null,
  isMainScreen: false,
  isAddNew: false,
  loading: false,
  errors: {}, // You can store the form errors here
  isActiveLoading: false, // You can store the active loading here
  isDeactiveLoading: false, // You can store the deactive loading here
  isResultsFound: false, // variable for result found here
  isContractsByIdResultsFound: false, // variable for result found here
  isContractsSearchResultsFound: false, // variable for result found here
  isAccountingGroupsResultsFound: false, // variable for result found here
  isCountryResultsFound: false, // variable for result found here
  isCustomersResultsFound: false, // variable for result found here
  isBillTosResultsFound: false, // variable for result found here
  isSitesResultsFound: false, // variable for result found here
  isBillToResultsFound: false, // variable for result found here
  isApprovalsResultsFound: false, // variable for result found here
  noDataFound: false, // variable for no data found here
  fastFindError: null, // variable for no data found here
  apiSuccessResponse: {
    activate: false,
    deactivate: false,
    create: false,
    update: false,
  }, // You can store the api success response here

  //Contracts Search Filters Expanded Collapse State
  contractsSearchFiltersExpanded: true, // You can store the contracts search expanded state here

  //Contracts Search Grid Show Hide State
  showContractsSearchGrid: false, // You can store the contracts search grid here

  //If contracts data fetch set this value or else set to false or reset it
  isContractsDataFetch: false, // You can store the is contracts data fetch here

  //Contracts Search Grid Show Hide State
  isContractsApprovalPage: false, // You can store the contracts approval page here

  //Contracts Search / Approval Page Navigation
  isContractsSearchPage: true, // You can store the contracts search page here

  //Contracts Add Page Navigation
  isContractsAddNewPage: false, // You can store the contracts add page here

  //Contarct Main Screen Automation Navigation
  isContractsMainScreen: false, // You can store the contracts main screen here

  //Contracts Main Screen Filter Expanded Collapse State
  isExpanded: true, // You can store the contracts main screen expanded state here

  //Contracts Main Screen Data
  mainScreenContractData: null,

  //Contract Id Search and Data fetched by Id
  contractsQuickSearchId: '', // You can store Quick Search Id here
  contractsSearchDatabyId: [], // You can store the contracts search data by id here

  //Contracts Search Grid Data
  contractsSearchGridData: [], // You can store the contracts data here
  contractsSearchColData: [], // You can store the contracts column Filter data here
  contractsSearchGridRowSelectedData: [], // You can store the grid row selected data here
  contractsSearchGridRowSelectedCount: 0,
  contractsSearchGridTotalRecords: 0, // You can store the total records of the grid here

  //Approval Grid Data
  approvalSearchGridData: [], // You can store the approval data here
  approvalSearchColData: [], // You can store the approval column Filter data here
  approvalGridRowSelectedData: [], // You can store the grid row selected data here
  approvalGridRowSelectedCount: 0,
  approvalGridTotalRecords: 0, // You can store the total records of the grid here
  approvalContractLoad: false,
  trickleLoad: false,
  queueArray: [{}],
  currentPage: 1,
  isReset: false,

  //Modals
  contractsSearchModal: {
    //Accounting Group
    openAccountingGroupModal: false, // You can store AccountingGrouo modal open status here
    accountingGroupSearchData: [], // You can store the AccountingGrouo search data here
    gridAccountingRowSelectedData: [], // You can store the grid row selected data here
    gridAccountingRowSelectedCount: 0, // You can store the grid rows selected count
    accountingGroups: [], // You can store the accounting groups here
    accountingGroupGridTotalRecords: 0, // You can store the total records of the grid here
    accountingGroupSearchForm: {
      accountingGroupCode: '',
      isActive: SWITCH_VALUE.yes,
      isResellerGroup: SWITCH_VALUE.no,
    },
    //Country
    openCountryModal: false, // You can store Country modal open status here
    countrySearchData: [], // You can store the AccountingGrouo search data here
    gridCountryRowSelectedData: [], // You can store the grid row selected data here
    gridCountryRowSelectedCount: 0, // You can store the grid rows selected count
    countries: [], // You can store the accounting groups here
    countryGridTotalRecords: 0, // You can store the total records of the grid here
    countrySearchForm: {
      name: '',
      countryCode: '',
    },
    //Customer
    openCustomerModal: false, // You can store Customer modal open status here
    customerSearchData: [], // You can store the Customersearch data here
    gridCustomerRowSelectedData: [], // You can store the grid row selected data here
    gridCustomerRowSelectedCount: 0, // You can store the grid rows selected count
    customers: [], // You can store the customers here
    customerGridTotalRecords: 0, // You can store the total records of the grid here
    customerSearchForm: {
      name: '',
      customerId: '',
    },
    //BillTo
    openBillToModal: false, // You can store BillTo modal open status here
    billToSearchData: [], // You can store the BillTosearch data here
    gridBillToRowSelectedData: [], // You can store the grid row selected data here
    gridBillToRowSelectedCount: 0, // You can store the grid rows selected count
    billTos: [], // You can store the billtos here
    billToGridTotalRecords: 0, // You can store the total records of the grid here
    billToSearchForm: {
      name: '',
      billToId: '',
    },
    //Site
    openSiteModal: false, // You can store Site modal open status here
    siteSearchData: [], // You can store the Sitesearch data here
    gridSiteRowSelectedData: [], // You can store the grid row selected data here
    gridSiteRowSelectedCount: 0, // You can store the grid rows selected count
    sites: [], // You can store the accounting groups here
    siteGridTotalRecords: 0, // You can store the total records of the grid here
    siteSearchForm: {
      name: '',
      siteId: '',
    },
  },

  //Contracts Search DropDowns
  levelDropDownData: [], // You can store the level dropdown data here
  statusDropDownData: [], // You can store the status dropdown data here

  //Search Data
  contractsSearch: {
    shortName: '',
    accountingGroupCode: '',
    accountingGroupName: '',
    countryId: 0,
    countryName: '',
    customerId: 0,
    customerName: '',
    billToId: 0,
    billToName: '',
    siteId: 0,
    siteName: '',
    statusId: 0,
    levelId: 0,
    isNoCountryCheck: CHECK_BOX_VALUE.no, // You can store the no country check here
    isNoCustomerCheck: CHECK_BOX_VALUE.no, // You can store the no customer check here
    isNoBillToCheck: CHECK_BOX_VALUE.no, // You can store the no bill to check here
    isNoSiteCheck: CHECK_BOX_VALUE.no, // You can store the no site check here
    recordsPerPage: GRID_ROWS_PER_PAGE.contractsGrid,
    pageNumber: GRID_ROWS_PER_PAGE.initialIndex,
  },
  //Approvals Search Grid Column Filters
  approvalGridColumnFilters: {
    accountingGroupName: '',
    countryCode: '',
    contractId: '',
    shortName: '',
    customerName: '',
    billToName: '',
    siteName: '',
    contractLevel: '',
    createdBy: '',
  },
  //contract Automated Screen
  isContractQuikSearch: false,
  isContractSelectRadio: false,
  isContractAprrovalGridRadio: false,
  //Add Contract Status
  statusSubmitted: 'Submitted',
  statusApproved: 'Approved',
  contractFieldStatus: 'contractStatus',
  //approval Queue
  approvalQueue: {
    startDate: null,
    endDate: null,
    startTime: null,
    endTime: null,
    isApprovalGridVisible: false,
  },
  contractGridLoading: false,
  approvalQueueNotes: null,
  approvalApiResponse: null,
  approvalSelectedRow: [],
  trickleApiResponse: false,
  trickleLoading: false,
  trickleData: [],
  description: '',
  isDescrptionUpdating: false,
  contractsTabsLength: 0,
  quickIconClicked: false,
  contractsForTrickleDown: [],
};
